/**
 * Heuristic to detect the dev/staging environment on the client.
 *
 * True when:
 *  - running under the Vite dev server (`import.meta.env.DEV`), or
 *  - `VITE_APP_ENV` is explicitly `dev`/`staging`, or
 *  - the hostname looks like a dev deploy (localhost / 127.* / a `dev` label)
 *
 * Production hosts (e.g. app.klaro7.com) return false.
 */
export function isDevEnv(): boolean {
  if (import.meta.env.DEV) return true;

  const appEnv = (import.meta.env.VITE_APP_ENV as string | undefined)?.toLowerCase();
  if (appEnv === 'dev' || appEnv === 'development' || appEnv === 'staging') return true;
  if (appEnv === 'prod' || appEnv === 'production') return false;

  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host.startsWith('127.')) return true;
  // matches dev.app.klaro7.com, dev.api..., staging.* etc. but not app.klaro7.com
  return /(^|\.)(dev|staging)\./.test(host) || host.startsWith('dev.');
}
